<div class="update-terms-and-conditions-dialog" [ngClass]="data.extraClass">
  <div class="update-terms-and-conditions-dialog__container">
    <div class="update-terms-and-conditions-dialog__illustration">
      <img src="/shared/img/terms-and-conditions/001.png" />
    </div>
    <div class="update-terms-and-conditions-dialog__text">
      <div class="update-terms-and-conditions-dialog__title">
        <h4 class="mat-headline-medium" ngClass.lt-576="mat-headline-6">
          We’ve updated our Terms
        </h4>
      </div>
      <div class="update-terms-and-conditions-dialog__message">
        <p class="mat-subtitle-1" ngClass.lt-576="mat-body-2">
          To continue, you need to confirm that you agree with our new
          <a
            class="link"
            href="/policies/terms"
            target="_blank"
            data-ga-value="new-terms-modal-link-tac"
            >Terms and Conditions</a
          >
          and
          <a
            class="link"
            href="/policies/privacy"
            target="_blank"
            data-ga-value="new-terms-modal-link-privacy"
            >Privacy Policy</a
          >.
        </p>
      </div>
    </div>
    <div class="update-terms-and-conditions-dialog__actions">
      <button
        mat-flat-button
        (click)="onAcceptTermsAndConditions($event)"
        [disabled]="data.accepting | async"
        data-ga-value="new-terms-modal-accept-tap"
        [ngClass]="{ 'mat-button-loading': data.accepting | async }"
      >
        ACCEPT NEW TERMS AND POLICY
      </button>
    </div>
  </div>
</div>
